import { css } from '@emotion/css';
import LoadingIcon from 'components/loading/LoadingIcon';
import { colors } from 'constants/theme';
import { useState } from 'react';

interface Props {
    onClose: () => void;
}

export default function ForgotPassword({ onClose }: Props) {
    const [loading] = useState(false);
    const [username, setUsername] = useState('');
    const [accountName, setAccountName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [phone, setPhone] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleSubmit = () => {
        if (!username || !accountName || !accountNumber || !phone || !newPassword || !confirmPassword) {
            return;
        }
        if (newPassword !== confirmPassword) {
            return;
        }
    };

    return (
        <>
            <div className={styles.wrapTransfer}>
                <div className="headerTitle">
                    <p className="title">Quên mật khẩu</p>
                    <img alt="" src={require('assets/images/fogot-pass/close.png')} onClick={onClose} className="iconClose" />
                </div>
                <div className={styles.container}>
                    <p className="title">Thông tin khách hàng</p>

                    <div className="containerInput">
                        <div className="viewInput">
                            <label className="labelInput">
                                <span className="require">*</span>Tên đăng nhập:
                            </label>
                            <input type="text" className="inputValue" value={username} onChange={(e) => setUsername(e.target.value)} />
                        </div>
                        <div className="viewInput">
                            <label className="labelInput">
                                <span className="require">*</span>Tên chủ tài khoản ngân hàng:
                            </label>
                            <input type="text" className="inputValue" value={accountName} onChange={(e) => setAccountName(e.target.value)} />
                        </div>
                        <div className="viewInput">
                            <label className="labelInput">
                                <span className="require">*</span>Số tài khoản ngân hàng:
                            </label>
                            <input type="text" className="inputValue" value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} />
                        </div>
                        <div className="viewInput">
                            <label className="labelInput">
                                <span className="require">*</span>Số điện thoại:
                            </label>
                            <input type="text" className="inputValue" value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </div>
                        <div className="viewInput">
                            <label className="labelInput">
                                <span className="require">*</span>Mật khẩu mới:
                            </label>
                            <input type="password" className="inputValue" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                        </div>
                        <div className="viewInput">
                            <label className="labelInput">
                                <span className="require">*</span>Nhập lại mật khẩu mới:
                            </label>
                            <input type="password" className="inputValue" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                        </div>
                        <div className="viewInput">
                            <label className="labelInput" />
                            <div className="button" onClick={handleSubmit}>
                                <p>Cập nhật</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    wrapTransfer: css`
        background: ${colors.white};
        border-radius: 8px;
        color: ${colors.white};
        position: relative;
        overflow: hidden;
        .iconClose {
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
        .headerTitle {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background-color: #f7f7f7;
            .title {
                color: #333;
                font-size: 17px;
            }
            padding: 10px 16px;
            border-bottom: 1px solid #eee;
        }
    `,
    container: css`
        padding: 25px;
        .viewInput {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 5px;
        }
        .title {
            font-size: 18px;
            margin-bottom: 10px;
            color: black;
        }
        .labelInput {
            text-align: right;
            width: 150px;
            color: #000;
            font-size: 13px;
            .require {
                color: #d90500;
            }
        }
        .inputValue {
            padding: 0 8px;
            border: 0;
            border-bottom: 1px solid #000;
            height: 35px;
            width: 40%;
            outline: none;
            font-size: inherit;
        }
        .button {
            background: #ffad33;
            height: 35px;
            width: 40%;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            border: 1px solid #c9820a;
            cursor: pointer;
            text-align: center;
        }
        .containerInput {
            padding-left: 80px;
            padding-right: 20px;
            gap: 20px;
            display: flex;
            flex-direction: column;
        }
    `,
};
